import { Get, GetEndpoint } from "../services/api_helpers"


// laws
export const GetLaws = () => {
    return Get('laws')
}
export const GetCodex = () => {
    return Get('kodeksler')
}
export const GetConstitution = () => {
    return Get('constitution')
}
export const GetConstitutionLaws = () => {
    return Get('constitutional-laws')
}

// laws table 
export const GetLawsTable = (location) => {
    return GetEndpoint('laws/' + location)
}
export const GetCodexTable = (location) => {
    return GetEndpoint('kodeksler/' + location)
}
export const GetConstitutionTable = (location) => {
    return GetEndpoint('constitution/' + location)
}
export const GetConstitutionLawsTable = (location) => {
    return GetEndpoint('constitutional-laws/' + location)
}

// news
export const GetNews = () => {
    return Get('news')
}
export const GetNewsTable = (location) => {
    return GetEndpoint('news/' + location)
}

// gallery
export const Galleries = () => {
    return Get('gallery')
}
export const GalleryCard = (location) => {
    return GetEndpoint('gallery/' + location)
}

//cities law-help
export const GetCitizens = () => {
     return Get('citizen-receptions')
}
export const GetCitizensTable = (location) => {
    return GetEndpoint('citizen-receptions/' + location)
}

// document sample
export const GetDocumentSample = () => {
    return Get('document-samples')
}
export const GetDocumentSampleTable = (location) => {
   return GetEndpoint('document-samples/' + location)
}

// Auctions
export const GetSale = () => {
    return Get('auctions')
}
export const GetSaleCard = (location) => {
   return GetEndpoint('auctions/' + location)
}


export const GetStateDuty = () => {
    return Get('state-duties')
}
export const GetCollectionDecisions = () => {
    return Get('collection-decision')
}
export const GetFaq = () => {
    return Get('faqs')
}
export const GetAbout = () => {
    return Get('about')
}
export const GetPages = () => {
    return Get('pages')
}
